<template>
  <div>
    <div class="max-w-4xl pt-8 pb-10 px-10">
      <!-- <div class="text-xl font-semibold mb-4">
      <p class="title">User Permissions</p>
    </div> -->
      <div class="flex items-center justify-between pb-5 mb-5 pl-0 border-b border-gray-100">
        <div class="flex items-center space-x-4">
          <el-avatar v-if="true" :size="40" shape="square" class="bg-indigo-50 text-brand-blue font-semibold">{{
            user.name
              .split(' ')
              .map((d) => d[0])
              .join('')
          }}</el-avatar>
          <div>
            <p class="title">{{ user.name }}</p>
            <p class="subtitle">{{ user.email }}</p>
          </div>
        </div>
        <div class="brand-input flex-grow-0 w-36 -mr-1">
          <!-- <p class="subtitle text-right text-gray-600 text-sm mb-2">Edit User Group</p> -->
          <el-select v-model="selectedRole" placeholder="Consultant" class="w-full pl-2">
            <el-option v-for="role in displayedRoles" :key="role.value" :label="role.label" :value="role.value" :disabled="role.disabled"></el-option>
          </el-select>
        </div>
      </div>
      <div class="space-y-4">
        <!-- Repeat this block for each permission -->
        <div v-for="perm in displayedPermissions" :key="perm.key" class="flex justify-between items-center">
          <div class="flex items-center space-x-4 py-0.5">
            <div class="w-8 h-8 bg-indigo-50 flex items-center justify-center rounded-md">
              <font-awesome-icon :icon="perm.icon" class="w-5 h-5 text-brand-blue" />
            </div>
            <div class="space-y-0.5">
              <span class="font-semibold text-gray-800">{{ perm.title }}</span>
              <p class="text-sm text-gray-600">{{ perm.description }}</p>
            </div>
          </div>
          <el-switch :value="perm.writeRoles.includes(selectedRole)"></el-switch>
        </div>
        <!-- Add more permissions as needed -->
      </div>
    </div>

    <div class="bg-brand-light-sand border-t-2 border-brand-sand flex justify-end px-8 py-5 rounded-b-lg">
      <el-button @click="$emit('close')" type="plain" class="border-brand-gray-blue border-2 px-6 py-2 rounded-lg">
        <span class="text-sm text-brand-blue font-semibold">Close</span>
      </el-button>
      <el-button
        :loading="saving"
        :disabled="selectedRole === user.role"
        @click="saveChanges"
        type="primary"
        class="font-bold py-2 px-6 rounded-lg text-sm"
        >Update {{ user.name.split(' ')[0] }}'s Role</el-button
      >
    </div>
  </div>
</template>

<script>
import userService from '@/api/user.service';
import { permissionsWithDetails, availableRoles } from '@/store/modules/permissions';

export default {
  name: 'EditUserRole',
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      selectedRole: this.user.role,
      saving: false,
    };
  },
  computed: {
    displayedPermissions() {
      return permissionsWithDetails.filter((permission) => !permission.hidden);
    },
    displayedRoles() {
      const userRole = this.$store.state.user.role;
      const userRoleIndex = availableRoles.findIndex((d) => d.value === userRole);
      return availableRoles.map((role) => {
        // check indexes of user role and role
        const targetRoleIndex = availableRoles.findIndex((d) => d.value === role.value);
        const disabled = targetRoleIndex < userRoleIndex;
        return {
          ...role,
          disabled,
        };
      });
    },
  },
  methods: {
    async saveChanges() {
      this.saving = true;
      try {
        await userService.updateUserRole(this.user._id, { role: this.selectedRole });
        this.$notify({ title: 'Success', message: 'User role updated', type: 'success' });
        this.user.role = this.selectedRole;
        this.$emit('updated');
      } catch (error) {
        this.$notify({ title: 'Error', message: 'Failed to update user role', type: 'error' });
      } finally {
        this.saving = false;
      }
      // Implement save logic here
      console.log('Saving changes...');
    },
  },
};
</script>

<style scoped>
/* Add any additional styles here */
</style>
